import Home from './Home/Home.vue';

import Olvido from './Registro/Olvido.vue';
import RestablecerContrasena from './Registro/RestablecerContrasena.vue';

import Terminos from './TerminosYCondiciones/TerminosYCondiciones.vue';


import Dashboard from './Dashboard/Dashboard.vue';

import Registro from './Registro/Registro.vue';
import EditarRegistro from './Registro/EditarRegistro.vue';

import ProcesoEndoso from './Endoso/ProcesoEndoso.vue';

import Renovacion from './Registro/Renovacion.vue';

import Endoso from './Registro/Endoso.vue';

import Detalle from './Registro/Detalle.vue';

import DetalleEndoso from './Endoso/Detalle.vue';

import Usuarios from './Usuarios/Usuarios.vue';
import NuevoUsuario from './Usuarios/NuevoUsuario.vue';
import MiPerfil from './Usuarios/MiPerfil.vue';

import Usuario from './Usuarios/Usuario.vue';

import cookie from 'vue-cookie';

import GenerarReporte from './Reportes/GenerarReporte.vue';

import Configuracion from './Configuracion/Configuracion.vue';

import Administradores from './Configuracion/Administradores.vue';


export const routes = [
    { path: '', component: Home },
    { path: '/', component: Home },

    /*{ path: '/registro', component: Registro },*/
    { path: '/recuperacion', component: Olvido },
    { path: '/restablecer-contrasena/:codigo/:user_id', component: RestablecerContrasena },

    { path: '/dashboard/', component: Dashboard },

    { path: '/usuarios/', component: Usuarios, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/nuevo-usuario/', component: NuevoUsuario, beforeEnter(to, from, next) { protectAdministrador(next) } },
    { path: '/mi-perfil/', component: MiPerfil },
    { path: '/usuario/:id', component: Usuario, beforeEnter(to, from, next) { protectAdministrador(next) } },

    { path: '/registro/', component: Registro, beforeEnter(to, from, next) { protectConsulta(next) } },

    { path: '/registro/:id', component: Detalle },
    //{ path: '/editar-registro/:id', component: EditarRegistro },


    { path: '/renovacion/:id', component: Renovacion, beforeEnter(to, from, next) { protectConsulta(next) } },

    { path: '/proceso-endoso/:id', component: Endoso, beforeEnter(to, from, next) { protectConsulta(next) } },

    { path: '/endoso/:id', component: DetalleEndoso },

    //{ path: '/proceso-endoso/', component: ProcesoEndoso },


    { path: '/reportes/generar-reporte', component: GenerarReporte },

    { path: '/configuracion/:id', component: Configuracion, beforeEnter(to, from, next) { protectAdministrador(next) } },


    { path: '/administradores/', component: Administradores, beforeEnter(to, from, next) { protectConfiguracionAdmins(next) } },

    // { path: '/dashboard/alumnos', component: Alumnos, beforeEnter(to, from, next) { protectAdministrador(next) } },
    // { path: '/dashboard/alumnos/alta', component: AlumnosAlta, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    // { path: '/dashboard/alumnos/edicion/:matricula', component: AlumnosEdicion, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },
    // { path: '/dashboard/alumnos/grupo/:id_grupo/:matricula', component: AlumnosGrupo, props: true, beforeEnter(to, from, next) { protectAdministrador(next) } },


];

function protectConsulta(next) {
    if (cookie.get('usergaig') != null) {
        var user_level = Object(JSON.parse(cookie.get('usergaig')).user_level);
        if (cookie.get('usergaig') != null && user_level == 1) {
            next();
        } else {
            //cookie.delete("usergaig");
            next('/dashboard');
        }
    } else {
        next('/');
    }
}


function protectAdministrador(next) {
    if (cookie.get('usergaig') != null) {
        var user_id = Object(JSON.parse(cookie.get('usergaig')).id);
        if (cookie.get('usergaig') != null && user_id == 1) {
            next();
        } else {
            //cookie.delete("usergaig");
            next('/dashboard');
        }
    } else {
        next('/');
    }
}

function protectConfiguracionAdmins(next) {
    if (cookie.get('usergaig') != null) {
        var user_id = Object(JSON.parse(cookie.get('usergaig')).id);
        if (cookie.get('usergaig') != null && (user_id == 1 || user_id == 38)) {
            next();
        } else {
            //cookie.delete("usergaig");
            next('/dashboard');
        }
    } else {
        next('/');
    }

}